export const roundToPrecision = (n: number, digitsAfterDecimal: number) => {
  const factor = Math.pow(10, digitsAfterDecimal)
  return Math.round(n * factor) / factor
}

export const ceilingToPrecision = (n: number, digitsAfterDecimal: number) => {
  const factor = Math.pow(10, digitsAfterDecimal)
  return Math.ceil(n * factor) / factor
}